<div class="add-vehicle-form-wrapper pt-24-md-px pt-sm-unset">
  <div class="flex-direction">
    @if (smLayout == true && (selectedVehicle || savedVehicles?.length > 0) ){
    <p-tabView class="mobile-tabs pb-24-px" (activeIndexChange)="mdActiveIndex = $event" [activeIndex]="mdActiveIndex">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="header-wrapper" (click)="disableAddVehicleFormInMd()">
            My vehicles
          </div>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="header-wrapper" (click)="enableAddVehicleFormInMd()">
            Add vehicle
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
    } @if ((smLayout == true && mdActiveIndex == 1) || (smLayout == false)) {
    <div class="upper-section" [class.pt-24-px]="
        smLayout == true &&
        !selectedVehicle &&
        (!savedVehicles || savedVehicles?.length == 0)
      ">
      <p class="input-comment">Add car plate number to get an exact fit</p>
      <!--
            <button pButton pRipple 
      (click)="loading = !loading" class="c-button primary d-none d-md-block">
      Loading
    </button>
      -->

      <div class="license-plate-block-wrapper">
        <app-inline-input-control [flagPrefix]="true" [type]="'text'" [control]="licensePlateControl"
          [label]="'Plate number:'" [name]="'license-plate'"></app-inline-input-control>

        <button pButton pRipple [disabled]="!licensePlateControl.value || !licensePlateControl.valid || loading"
          (click)="getVehicleModificationsByLicensePlate()" class="c-button primary d-none d-md-block">
          Search
        </button>
      </div>
      <button pButton pRipple [disabled]="!licensePlateControl.value || !licensePlateControl.valid || loading"
        (click)="getVehicleModificationsByLicensePlate()" class="c-button primary w-100 d-md-none mb-32-md-px">
        Search
      </button>
      @if (showManualForm && !notFoundByLicensePlate &&
      !selectVehiclesFromLicensePlateSearch) {
      <p class="input-comment"><b>OR</b> select manually</p>


      <!--
                  <div class="tabs-wrapper mb-24-px">
        <p-tabView [activeIndex]="vehicleTabActiveIndex" (onChange)="onVehicleTabChange($event)"
          styleClass="primary-tabs no-content in-dialog">
          @for(vehicleType of vehicleTypes; track vehicleType.value){
          <p-tabPanel [disabled]="loading">
            <ng-template pTemplate="header">
              <h4>{{ vehicleType.label }}</h4>
            </ng-template>
          </p-tabPanel>
          }
        </p-tabView>
      </div> 
      -->





      <form class="manual-vehicle-form" [formGroup]="addVehicleFormGroup">
        <app-dropdown-control [appendTo]="'body'" (triggerAfterClearEvent)="onYearCleared()"
          [optionsSearchEnabled]="true" [label]="'Year'" [showClear]="true" [options]="years"
          [control]="addVehicleFormGroup.controls[AddVehicleFields.Year]" [name]="AddVehicleFields.Year"
          [classess]="'mb-unset'" [disabled]="loading" [loading]="loading" [optionMultiLines]="true">
        </app-dropdown-control>

        <app-dropdown-control [appendTo]="'body'" (triggerAfterClearEvent)="onBrandCleared()"
          [optionsSearchEnabled]="true" [label]="'Brand'" [showClear]="true" [options]="brands"
          [control]="addVehicleFormGroup.controls[AddVehicleFields.Brand]" [name]="AddVehicleFields.Brand"
          [classess]="'mb-unset'" [disabled]="
            loading ||
            !addVehicleFormGroup.controls[AddVehicleFields.Year]?.value
          " [loading]="loading" [optionMultiLines]="true"></app-dropdown-control>

        <app-dropdown-control [appendTo]="'body'" (triggerAfterClearEvent)="onModelCleared()"
          [optionsSearchEnabled]="true" [label]="'Model'" [showClear]="true" [options]="models"
          [control]="addVehicleFormGroup.controls[AddVehicleFields.Model]" [name]="AddVehicleFields.Model"
          [classess]="'mb-unset'" [disabled]="
            loading ||
            !addVehicleFormGroup.controls[AddVehicleFields.Brand]?.value
          " [loading]="loading" [optionMultiLines]="true"></app-dropdown-control>

        <app-dropdown-control [appendTo]="'body'" (triggerAfterClearEvent)="onEngineCleared()"
          [optionsSearchEnabled]="true" [label]="'Engine'" [showClear]="true" [options]="engines"
          [control]="addVehicleFormGroup.controls[AddVehicleFields.Engine]" [name]="AddVehicleFields.Engine"
          [classess]="'mb-unset'" [disabled]="
            loading ||
            !addVehicleFormGroup.controls[AddVehicleFields.Model]?.value
          " [loading]="loading" [optionMultiLines]="true"></app-dropdown-control>

        <!--
            <app-autocomplete-control [label]="'Brand'" [options]="filteredBrands" [appendTo]="'body'"
              [control]="addVehicleFormGroup.controls[AddVehicleFields.Brand]" [name]="AddVehicleFields.Brand"
            (autocompleteValueChanges)="filterBrands($event)" [classess]="'mb-unset'"></app-autocomplete-control>

            <app-autocomplete-control [label]="'Model'" [options]="filteredModels" [appendTo]="'body'"
              [control]="addVehicleFormGroup.controls[AddVehicleFields.Model]" [name]="AddVehicleFields.Model"
            (autocompleteValueChanges)="filterModels($event)" [classess]="'mb-unset'"></app-autocomplete-control>

            <app-autocomplete-control [label]="'Engine'" [options]="filteredEngines" [appendTo]="'body'"
              [control]="addVehicleFormGroup.controls[AddVehicleFields.Engine]" [name]="AddVehicleFields.Engine"
            (autocompleteValueChanges)="filterEngines($event)" [classess]="'mb-unset'"></app-autocomplete-control>
            -->
      </form>
      } @if(notFoundByLicensePlate){
      <div class="not-found-block">
        <h3>
          Sorry, no vehicles were found with the plate number
          <b>“{{ licensePlateControl?.value }}”</b>
        </h3>
        <a pRipple (click)="clearNotFound()">Select vehicle manually</a>
      </div>
      } @if(selectVehiclesFromLicensePlateSearch){
      <div class="license-plate-search-results">
        <p class="section-label">
          <span class="text">Select a vehicle:</span>
        </p>
        <div class="vehicles">
          @for(vehicle of vehicleModificationsByLicensePlate; track vehicle.id){
          <div (click)="!loading &&  addVehicleToMySavedList(vehicle)" class="vehicle"
           [class.disabled]="loading">
            <div class="content pr-8-px">
              <img [src]="
                  vehicle.images?.url100
                    ? vehicle.images?.url100
                    : './../../../../assets/images/vehicles/vehicles-basic-placeholder.svg'
                " alt="vehicle-img" />
              <p class="vehicle-description">
                {{ vehicle?.manufacturer?.name }} {{ vehicle?.model?.name }}
                {{ vehicle?.name }}
                <span class="years"><b>{{ vehicle?.period }}</b></span>
              </p>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
    } @if ((smLayout == true && mdActiveIndex == 0) || (smLayout == false)) {
    @if(selectedVehicle || savedVehicles?.length > 0){
    <div class="lower-section" [class.mt-24-px]="addVehicleFormGroup && !smLayout">
      <div class="flex-rows">
        @if(selectedVehicle){
        <div class="my-vehicles">
          <p class="section-label with-action">
            <span class="text">Currently shopping for:</span>
            <span pRipple (click)="!loading && removeVehicleFromActive()" class="action" [class.disabled]="loading">Shop
              without vehicle</span>
          </p>
          <div class="vehicles">
            <div class="vehicle">
              <div class="content">
                <img [src]="
                    selectedVehicle.details?.images?.url100
                      ? selectedVehicle.details?.images?.url100
                      : './../../../../assets/images/vehicles/vehicles-basic-placeholder.svg'
                  " alt="vehicle-img" />
                <p class="vehicle-description">
                  {{ selectedVehicle?.year }}
                  {{ selectedVehicle?.details?.manufacturer?.name }}
                  {{ selectedVehicle?.details?.model?.name }}
                  {{ selectedVehicle?.details?.modification?.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
        } @if(savedVehicles?.length > 0){
        <div class="other-vehicles">
          <p class="section-label">
            <span class="text">{{
              selectedVehicle ? "Saved vehicles" : "Select saved vehicle:"
            }}</span>
            <!--
                      <span class="action">Manage vehicles</span>
                      -->
          </p>
          <div class="vehicles">
            @for(vehicle of savedVehicles; track vehicle.id){
            <div (click)="!loading && selectedVehicle?.id !== vehicle?.id && setActiveVehicle(vehicle.id)"
              class="vehicle" [class.disabled]="loading || selectedVehicle?.id == vehicle?.id">
              <div class="content pr-8-px">
                <img [src]="
                    vehicle.details?.images?.url100
                      ? vehicle.details?.images?.url100
                      : './../../../../assets/images/vehicles/vehicles-basic-placeholder.svg'
                  " alt="vehicle-img" />
                <p class="vehicle-description">
                  {{ vehicle?.year }}
                  {{ vehicle?.details?.manufacturer?.name }}
                  {{ vehicle?.details?.model?.name }}
                  {{ vehicle?.details?.modification?.name }}
                </p>
              </div>
              @if(selectedVehicle?.id !== vehicle?.id){
              <button (click)="
                !loading && removeVehicleFromSaved(vehicle.id); $event.stopPropagation()
              " class="c-button icon-only p-unset" pButton pRipple>
                <img class="inner-icon" src="./../../../../assets/images/icons/delete-primary.svg" alt="remove" />
              </button>
              } @else {

              }
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
    } }
  </div>
</div>
